import React, { FC, useMemo } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

type Props = {
  children?: any;
  Title: React.ReactElement | string;
  HeaderContent?: React.ReactElement;
  styles?: Partial<
    Record<'container' | 'headerContainer' | 'title', SxProps<Theme>>
  >;
};

const ViewBase: FC<Props> = ({ Title, styles, HeaderContent, children }) => {
  const {
    containerStyles,
    headerContainerStyles,
    titleStyles,
  }: Record<string, SxProps<Theme>> = useMemo(() => {
    return {
      containerStyles: {
        p: ({ spacing }) => spacing(1, 3),
        ...(styles?.container ?? {}),
      },
      headerContainerStyles: {
        ...(styles?.headerContainer ?? {}),
      },
      titleStyles: {
        fontSize: ({ spacing }) => spacing(4.375),
        ...(styles?.title ?? {}),
      },
    };
  }, []);

  return (
    <Box display="flex" flexDirection="column" gap={1.5} sx={containerStyles}>
      <Box
        display="flex"
        flexWrap="nowrap"
        justifyContent="space-between"
        alignItems="center"
        sx={headerContainerStyles}
      >
        <Box
          sx={{
            '& > p': {
              ...(titleStyles as any),
            },
          }}
        >
          {Title}
        </Box>
        {HeaderContent}
      </Box>
      {children}
    </Box>
  );
};

export default ViewBase;
